import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import SkeletonCard from "./SkeletonCard";
import { useAuth } from "../context/AuthContext";

const roleRoutes = {
  CUSTOMER: "/dashboard",
  ADMIN: "/admindashboard",
  AGENT: "/agentdashboard",
  SUPER_ADMIN: "/superdashboard",
};

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user) {
    return <Navigate to={roleRoutes[user.role] || "/dashboard"} />;
  }

  return children;
}
